// Field choices for the global M3U Hash Key and per-account Hash Key Override
// Multiselects. Keep in sync with apps.m3u.utils.M3U_HASH_KEY_FIELDS.
export const M3U_HASH_KEY_OPTIONS = [
  { value: 'name', label: 'Name' },
  { value: 'url', label: 'URL' },
  { value: 'tvg_id', label: 'TVG-ID' },
  { value: 'm3u_id', label: 'M3U ID' },
  { value: 'group', label: 'Group' },
];
